import { createTheme } from '@material-ui/core/styles';
import baseTheme from './baseTheme';
import COLORS from '../utils/constants/colors';

const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    primary: {
      main: COLORS.SR_GUNMETAL_GREY_80, // shade of green
      light: COLORS.SR_GUNMETAL_GREY_60,
    },
    secondary: {
      main: COLORS.SR_LINK_WATER_80,
      light: COLORS.WHITE,
      contrastText: '#fafafa',
      dark: COLORS.DARK_GREY,
    },
    background: {
      paper: COLORS.SR_GUNMETAL_GREY_90,
      default: COLORS.SR_GUNMETAL_GREY_100,
      dark: COLORS.SR_GUNMETAL_GREY_60,
    },
    text: {
      primary: COLORS.WHITE,
      secondary: COLORS.LIGHT_GREY,
      disabled: COLORS.DISABLED_GREY_LIGHT,
    },
  },
});

export { darkTheme };
